import script from "./AdminProjectEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProjectEditorView.vue?vue&type=script&setup=true&lang=js"

import "./AdminProjectEditorView.vue?vue&type=style&index=0&id=82a3a4b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82a3a4b0"]])

export default __exports__